import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { EventProvider } from '../../providers/event/event';
import { GlobalUtil } from '../../tracker/global-utils';
import { GpsTracker } from '../../tracker/gps-tracker';
import { Router } from '@angular/router';

@Component({
    selector: 'inbrowser',
    templateUrl: 'inbrowser.html',
    styleUrls:['./inbrowser.scss']
})
export class InBrowserPage {
    url;
    routerState:any;

    constructor(private router:Router, private eventService: EventProvider, private sanitizer: DomSanitizer) {
        console.log('ionView')
        const nav = this.router.getCurrentNavigation();
        this.routerState = nav?.extras?.state || {};


        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.routerState["link"]);
        console.log('this.url: ', this.url);
    }

    ionViewWillLeave() {
        console.log('ionViewWillLeave: ');
        // this.eventService.onBackPage(GlobalUtil.getInstance().currentEventID).then(res => console.log(res));
    }


}
